// import { CircularProgress, Container, Typography } from "@mui/material";
export default function NotFound() {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "10%",
        fontSize: "25px",
        color: "red",
      }}
    >
      <span>
        Đường dẫn không tồn tại, vui lòng quay lại{" "}
        <a href={"/"} style={{ color: "blue" }}>trang chủ</a>
      </span>
    </div>
  );
}
